import { ClientResponseModel, PriceAlertResponseModel } from "../../../../../pure-javascript-api/lib-export/everything";
import { ChartStyleColorModel } from "../../models/chart-style/chart-style-color.model";
import { LimitAlertModel } from "../../models/limit-alert/limit-alert.model";

export class JSApiPriceAlertToLimitAlertMapper {
    public static map(rawData: ClientResponseModel<Array<PriceAlertResponseModel>>, symbol: string): Array<LimitAlertModel> {
        if (!rawData.isSuccess) {
            return [];
        }
        
        const result: Array<LimitAlertModel> = [];
        const alerts = rawData.data?.filter((x => x.symbol?.toLowerCase() == symbol.toLowerCase())) ?? [];

        for (const alert of alerts) {
            const model = new LimitAlertModel();
            model.id = alert.id;
            model.price = alert.price;
            model.symbol = alert.symbol;
            model.tooltip = alert.tooltip;
            model.status = alert.status;
            model.triggered = alert.triggered;
            model.created = alert.created;
            model.imageAnnotationName = alert.status;
            model.color = this.getAnnotationColor(alert.status);
            result.push(model);
        }

        return result;
    }

    private static getAnnotationColor(status: string): ChartStyleColorModel {
        var toReturn = new ChartStyleColorModel({r: 64, g: 114, b: 232});
        if (status == "EXPIRED")
            toReturn = new ChartStyleColorModel({ r: 176, g: 64, b: 190});
        else if (status == "TRIGGERED")
            toReturn = new ChartStyleColorModel({ r: 0, g: 255, b: 0});
        else if (status == "INVALIDATED")
            toReturn = new ChartStyleColorModel({ r: 255, g: 0, b: 0});

        return toReturn;
    }
}